module.exports = __webpack_public_path__ + "img/austral-sign.dda003e0.svg";